import React from 'react';
import Container from '../../../components/container';
import MigrationSteps from './components/steps';

const Migration = () => (
  <Container pageTitle="Migration">
    <MigrationSteps />
  </Container>
);
export default Migration;
